"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const calculateCappedSessionDuration_1 = __importDefault(require("../../utils/calculateCappedSessionDuration"));
function updateQuizTotalStudyTime({ totalStudyTime: existingTotalStudyTime }, modules) {
    const sessionStudyTime = (0, calculateCappedSessionDuration_1.default)(modules);
    return (existingTotalStudyTime || 0) + sessionStudyTime;
}
exports.default = updateQuizTotalStudyTime;
